import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';
import {DownloadService} from '../../../services/download.service';
import {SnackbarService} from '../../../services/snackbar.service';
import {SpinnerService} from '../../../services/spinner.service';
import {DatePipe} from '@angular/common';
import Swal from 'sweetalert2';
import {MatDialog} from '@angular/material/dialog';
import {FormatCurrencyPipe} from '../../../share/components/pipe/FormatCurrency.pipe';
import {ParseCurrencyPipe} from '../../../share/components/pipe/ParseCurrency.pipe';
import {
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  PageDTOTarifaGestorSDDRCADTO,
  ProvinciaControllerService,
  TarifaGestorSddrcaControllerService,
  TarifaGestorSDDRCAFilterDTO
} from 'api-rest';
import {SddrCaRateDialogComponent} from "../sddr-ca-rate-dialog/sddr-ca-rate-dialog.component";
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'app-sddr-ca-rate-search',
  templateUrl: './sddr-ca-rate-search.component.html',
  styleUrls: ['./sddr-ca-rate-search.component.scss'],
})
export class SddrCaRateSearchComponent implements OnInit {
  searchForm: FormGroup;
  codigosLerEndpoint = this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?sddrCA=true';
  gestoresEndpoint = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos?gestoresResiduosEstado.id=2&acondicionadorEnvase=true';
  provinciaArray: any[] = [];
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  flagSearch: boolean = false;
  totalSearch: number = 0;
  defaultFilter: boolean = true;
  mostrarFiltros: boolean = true;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  headArray: any = [
    {
      Head: 'Año',
      FieldName: 'anio',
    },
    {
      Head: 'Gestor',
      FieldName: 'gestoresResiduosModel',
      renderValue: (item: any) => `${item.gestoresResiduosModel.razonSocial} - ${item.gestoresResiduosModel.centro}`,
      Tooltip: true,
      Maxtext: 60,
    },
    {
      Head: 'Provincia',
      FieldName: 'provincia',
      renderValue: (item: any) => item.provincia?.nombre || item.gestoresResiduosModel?.domicilios?.[0]?.provincia?.nombre || item.gestoresResiduosModel?.domicilios?.[0]?.provinciaRef?.nombre,
    },
    {
      Head: 'Código LER y descripción de ENVALORA',
      FieldName: 'codigoLer',
      renderValue: (item: any) =>
        `${item.codigoLer.tipoCodigo} ${item.codigoLer.descripcion}`,
      Tooltip: true,
      Maxtext: 60,
    },
    {
      Head: '€/kg',
      FieldName: 'valorTarifa',
      renderValue: (item: any) =>
        this.formatCurrencyPipe.transform(item.valorTarifa),
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'view', icon: 'open_in_new', toolTip: 'Editar' },
        { nameButton: 'delete', icon: 'delete', toolTip: 'Borrar' },
      ],
      width: '10',
    },
  ];
  gridArray: any[] = [];

  fechaDesde: Date = new Date(new Date().getFullYear(), 0, 1);
  fechaHasta: Date = new Date(new Date().getFullYear(), 11, 31);
orden: DiccionarioElementoDTO[] = [];
  constructor(
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private downloadService: DownloadService,
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private provinciaControllerSrv: ProvinciaControllerService,
    private tarifaSddrcaControllerSrv: TarifaGestorSddrcaControllerService,
    private dialog: MatDialog,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService,
        @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService
  ) {
    this.searchForm = this.formBuilder.group({
      anio: [
        { value: new Date().getFullYear(), disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoLer: [{ value: null, disabled: false }],
      provincia: [{ value: null, disabled: false }],
      gestor: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }
  ngOnInit() {
    this.getComboProvincia();
    this.comboOrden();
  }
    comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ADMIN_TARIFAS_GESTORES_SDDR_ABIERTO_BUSQUEDA'])
      .subscribe((res) => (this.orden = res['ORDEN_ADMIN_TARIFAS_GESTORES_SDDR_ABIERTO_BUSQUEDA']));
  }
  getLerDescription(ler: any) {
    return ler?.tipoCodigo + ' - ' + ler?.descripcion;
  }

  getGestorDescription(gestor: any) {
    return gestor?.razonSocial;
  }

  getOperacionDescription(op: any) {
    return op?.descripcion;
  }
  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.searchForm.get('codigoLer') as FormControl;
      }
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm
    };
  }

  getGestorQuery(searchterm: string) {
    return {
      razonSocial: `${searchterm}`,
    };
  }
  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }
  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  getComboProvincia() {
    this.provinciaControllerSrv
      .listarComunidades1({}, { page: 0, size: 500 })
      .subscribe({
        next: (data: any) => {
          this.provinciaArray = data.datos!;
        },
        error: () => {},
      });
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  limpiar(): void {
    this.searchForm.reset();
    this.gridArray = [];
    this.flagSearch = false;
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.obtenerTarifas();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const anio = this.searchForm.get('anio')?.value;
    if (anio) filtros.push({ label: ` ${anio}`, campo: 'anio' });

    const codigoLer = this.searchForm.get('codigoLer')?.value;
    if (codigoLer) {
      filtros.push({ label: ` ${this.getLerDescription(codigoLer)}`, campo: 'codigoLer' });
    }

    const provincia = this.searchForm.get('provincia')?.value;
    if (provincia) {
      filtros.push({ label: `${provincia?.nombre ?? String(provincia)}`, campo: 'provincia' });
    }

    const gestor = this.searchForm.get('gestor')?.value;
    if (gestor) {
      const label = gestor?.centro ? `${gestor.razonSocial} - ${gestor.centro}` : this.getGestorDescription(gestor);
      filtros.push({ label: `${label}`, campo: 'gestor' });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  buscar(): void {
    this.pageNumber = 1;
    this.obtenerTarifas();
  }

  obtenerTarifas(): void {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.tarifaSddrcaControllerSrv.findAllTarifaGestorSDDRCA(backendFilter, {
      page: page,
      size: size,
      sort: ['anio,asc'],
    }, orden, tipoOrden).subscribe({
        next: (data: PageDTOTarifaGestorSDDRCADTO) => {
          if (data) {
            this.flagSearch = data.datos?.length !== 0 ? true : false;
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    const filter = this.searchForm.value;
    if (filter.provincia) {
      filter.provincia = {
        id: filter.provincia.id,
      };
    }

    if (filter.codigoLer) {
      filter.codigoLer = {
        id: filter.codigoLer.id,
      };
    }
    if (filter.gestor) {
      filter.gestor = {
        id: filter.gestor.id,
      };
    }

    const backendFilter: TarifaGestorSDDRCAFilterDTO | any = {
      anio: filter.anio,
      gestoresResiduosModel: filter.gestor,
      codigoLer: filter.codigoLer,
      provincia: filter.provincia,
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
        const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }
  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar();
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.obtenerTarifas();
    }
  }
  action(element: any) {
    if (element.nameButton == 'view') {
      this.abrirModalTarifa(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    }
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.tarifaSddrcaControllerSrv.exportCSV(backendFilter, 'response')
      .subscribe((res) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_TarifasGestoresSDDRCA.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: '¿Desea eliminar la tarifa?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarTarifa(element);
      }
    });
  }

  eliminarTarifa(element: any): void {
    this.spinnerSrv.loadingShow();
    this.tarifaSddrcaControllerSrv.deleteByIdTarifaGestorSDDRCA(element.id)
      .subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La tarifa se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar la tarifa',
            'error'
          );
        },
      });
  }

  abrirModalTarifa(tarifa?: any): void {
    const dialogRef = this.dialog.open(SddrCaRateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        tarifa: tarifa,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscar();
      }
    });
  }
canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    } 
}
